import moment from 'moment';
import React, { useEffect, useState, useMemo } from 'react'
import { getRequestBalanceExpiration } from '../../../services/balance/balanceRequest';
import { useSweetAlert } from '../../../hooks/sweetAlerts/useSweetAlert';
import * as XLSX from 'xlsx';
import { Card, CardBody, Col, Input, Label, Row, Button } from 'reactstrap'
import Select from 'react-select';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Bar } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useHistory } from 'react-router-dom';




export const IndexOverdueInvoices = () => {

	const history = useHistory();


	// * REPORT OVERDUE INVOICES
	const [filtersBalance, setFiltersBalance] = useState({
		dateStart: moment().format("YYYY-MM") + "-01",
		dateEnd: moment().endOf('month').format("YYYY-MM-DD"),
		clientId: null,
		commercialLineId: null,
		status: null

	});

	const [loadingBalance, setLoadingBalance] = useState(false);
	const [listOfClients, setListOfClients] = useState([]);
	const [reportBalance, setReportBalance] = useState([]);
	const [expandedRows, setExpandedRows] = useState(null);
	const [downloading, setDownloading] = useState(false);
	const [createSweet] = useSweetAlert();


	// ? TIME DOWNLOAD SIMULATION
	const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));


	useEffect(() => {
		handleGetReportBalance();
	}, []);


	// ? GET REPORT OVERDUE INVOICES
	const handleGetReportBalance = async () => {
		setLoadingBalance(true);
		setReportBalance([]);
		setListOfClients([]);

		try {
			const data = await getRequestBalanceExpiration(
				filtersBalance?.dateStart,
				filtersBalance?.dateEnd,
				filtersBalance?.commercialLineId,
				filtersBalance?.clientId,
				filtersBalance?.status
			);

			if (data && data.length > 0) {
				setReportBalance(data);

				const uniqueClients = [
					...new Map(
						data.map(item => [
							item?.clientId,
							{
								id: item?.clientId,
								name: item?.clientName
							}
						])
					).values()
				];

				setListOfClients(uniqueClients);

			} else {
				setReportBalance([]);
				setListOfClients([]);
			}

		} catch (error) {
			createSweet("error", "error", "Opss..", "Error al obtener el reporte de facturas vencidas. Por favor, intenta de nuevo.");
		}

		setLoadingBalance(false);
	};

	// ? EXCEL
	async function exportToExcelBalance(_reportBalance) {
		try {
			setDownloading(true);

			await sleep(300);

			let _Report = [];

			_reportBalance.forEach((client) => {
				(client.reportExpirationDateList || []).forEach((inv) => {
					_Report.push({
						"#": _Report.length + 1,
						Cliente: client?.clientName ?? '',
						RazonSocial: client?.commercialLine ?? '',
						RFC: client?.rfc ?? '',
						EstadoFactura: inv?.statusInvoice ?? '',
						Folio: inv?.folio ?? '',
						DiasCredito: inv?.creditDays ?? 0,
						FechaEmision: inv?.issuedDate ?? '',
						FechaVencimiento: inv?.expirationDate ?? '',
						MontoFacturado: inv?.amount ?? 0,
						MontoPagado: inv?.paymentAmount ?? 0,
						DiasAtraso: inv?.daysOverdue ?? 0,
						Estatus: getStatus(inv),
						Pagada: inv?.isPaid === 1 ? 'Sí' : 'No',
						FechaPago: inv?.paymentDate ?? 'Sin pago'
					});
				});
			});

			const totalFacturado = _Report.reduce((acc, r) => acc + (r.MontoFacturado || 0), 0);
			const totalPagado = _Report.reduce((acc, r) => acc + (r.MontoPagado || 0), 0);

			_Report.push({
				"#": '',
				Cliente: '',
				RazonSocial: '',
				RFC: '',
				EstadoFactura: '',
				Folio: '',
				DiasCredito: '',
				FechaEmision: '',
				FechaVencimiento: '',
				MontoFacturado: totalFacturado,
				MontoPagado: totalPagado,
				DiasAtraso: '',
				Estatus: 'TOTALES',
				Pagada: '',
				FechaPago: ''
			});

			const worksheet = XLSX.utils.json_to_sheet(_Report);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, 'Balance');

			const excelBuffer = XLSX.write(workbook, {
				bookType: 'xlsx',
				type: 'array'
			});

			const dataBlob = new Blob([excelBuffer], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});

			const fileName = 'Facturas_vencidas.xlsx';

			const url = window.URL.createObjectURL(dataBlob);
			const link = document.createElement('a');
			link.href = url;
			link.download = fileName;
			link.click();
			window.URL.revokeObjectURL(url);

		} finally {
			setDownloading(false);
		}
	}


	const number_format = (cantidad, decimals) => {
		cantidad += '';
		cantidad = parseFloat(cantidad.replace(/[^0-9\.]/g, ''));

		decimals = decimals || 0;

		if (isNaN(cantidad) || cantidad === 0) {
			return parseFloat(0).toFixed(decimals);
		}

		cantidad = '' + cantidad.toFixed(decimals);

		let cantidad_parts = cantidad.split('.'),
			regexp = /(\d+)(\d{3})/;

		while (regexp.test(cantidad_parts[0]))
			cantidad_parts[0] = cantidad_parts[0].replace(regexp, '$1' + ',' + '$2');

		return cantidad_parts.join('.');
	}


	// ? CONFIGURATION DATATABLE
	const headerStyle =
	{
		backgroundColor: "#1d5b83",
		color: "#fff",
		fontWeight: "bold",
		fontSize: "11px",
		borderRight: "1px solid #fff",
		borderBottom: "2px solid #fff",
	};

	const cellStyle =
	{
		fontSize: "11px",
		padding: "5px",
		textAlign: "center",
		fontFamily: "Montserrat, sans-serif",
	};

	const centerStyle =
	{
		...cellStyle,
		textAlign: "center",
		zIndex: 2, border: "1px solid #cccccc9c",
		borderCollapse: "collapse"
	};

	function getStatus(row) {
		if (row.isPaid === 1) return "Pagado";

		const today = new Date();
		today.setHours(0, 0, 0, 0);

		const exp = new Date(row.expirationDate);
		exp.setHours(0, 0, 0, 0);

		if (exp < today) return "Vencida";
		if (exp.getTime() === today.getTime()) return "Vence hoy";

		return "Vigente";
	}

	const formatDateTime = (date) => {
		if (!date) return '---';

		return new Date(date).toLocaleString('es-MX', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit'
		});
	};

	const totalGeneral = reportBalance.reduce((acc, row) => {
		const totalRow = row.reportExpirationDateList
			?.filter(inv => inv?.statusInvoice !== "Cancelada")
			.reduce((sum, inv) => sum + (inv?.amount ?? 0), 0) || 0;

		return acc + totalRow;
	}, 0);

	const footerStyle = {
		backgroundColor: '#000',
		color: '#fff',
		fontWeight: 'bold',
		textAlign: 'center',
		fontSize: '0.75rem',
		padding: '4px',
	};


	const totalPaidGeneral = reportBalance.reduce((acc, row) => {
		const totalPaidRow = row.reportExpirationDateList?.reduce(
			(sum, inv) => sum + (inv.paymentAmount ?? 0),
			0
		) || 0;

		return acc + totalPaidRow;
	}, 0);


	const rowExpansionTemplate = (rowData) => {
		const totalFacturado = rowData?.reportExpirationDateList
			.filter(r => r?.statusInvoice !== "Cancelada")
			.reduce((acc, r) => acc + (r?.amount ?? 0), 0);

		const totalPagado = rowData?.reportExpirationDateList.reduce(
			(acc, r) => acc + (r?.paymentAmount ?? 0),
			0
		);

		return (
			<div className="p-3">
				<DataTable
					value={rowData?.reportExpirationDateList}
					rowClassName={(row) =>
						row?.statusInvoice === "Cancelada" ? "row-cancelada" : ""
					}
				>
					<Column
						field="statusInvoice"
						header="Estado"
						headerStyle={headerStyle}
						style={centerStyle}
						body={(row) => {
							const isTimbrada = row?.statusInvoice === "Timbrada";

							return (
								<span
									style={{
										color: isTimbrada ? "#16a34a" : "#dc2626",
										fontWeight: 600
									}}
								>
									{row?.statusInvoice}
								</span>
							);
						}}
					/>

					<Column
						field="folio"
						header="Folio"
						headerStyle={headerStyle}
						style={centerStyle}
					/>

					<Column
						field="uuid"
						header="UUID"
						headerStyle={headerStyle}
						style={centerStyle}
					/>

					<Column
						field="creditDays"
						header="Días de crédito"
						headerStyle={headerStyle}
						style={centerStyle}
					/>

					<Column
						field="issuedDate"
						header="Fecha emisión"
						headerStyle={headerStyle}
						style={centerStyle}
						body={(row) => (
							<span style={{
								background: '#e3f2fd',
								padding: '4px 8px',
								borderRadius: '6px',
								display: 'inline-block',
								width: '100%'
							}}>
								{formatDateTime(row?.issuedDate)}
							</span>
						)}
					/>

					<Column
						field="amount"
						header="Monto Facturado"
						headerStyle={headerStyle}
						style={centerStyle}
						body={(row) => `$${number_format(row?.amount, 2)}`}
						footer={`$${number_format(totalFacturado, 2)}`}
						footerStyle={footerStyle}
					/>

					<Column
						field="expirationDate"
						header="Vencimiento"
						headerStyle={headerStyle}
						style={centerStyle}
						body={(row) => {

							const today = new Date();
							today.setHours(0, 0, 0, 0);

							const exp = new Date(row?.expirationDate);
							exp.setHours(0, 0, 0, 0);

							let bg = '#e8f5e9';
							let color = '#2e7d32';

							if (exp < today) {
								bg = '#fdecea';
								color = '#d32f2f';
							} else if (exp.getTime() === today.getTime()) {
								bg = '#fff7ed';
								color = '#f59e0b';
							}

							return (
								<span style={{
									background: bg,
									color: color,
									padding: '4px 8px',
									borderRadius: '6px',
									display: 'inline-block',
									width: '100%',
									fontWeight: 600
								}}>
									{new Date(row?.expirationDate).toLocaleDateString('es-MX')}
								</span>
							);
						}}
					/>

					<Column
						field="daysOverdue"
						header="Días de retraso"
						headerStyle={headerStyle}
						style={centerStyle}
						body={(row) => {

							if ((row?.statusInvoice ?? "").toLowerCase() === "cancelada") {
								return (
									<Tag
										value="N/A"
										style={{
											background: 'transparent',
											border: 'none',
											color: '#6b7280',
											fontWeight: 600
										}}
									/>
								);
							}

							if (row?.isPaid === 1) {
								return (
									<Tag
										value="N/A"
										style={{
											background: 'transparent',
											border: 'none',
											color: '#6b7280',
											fontWeight: 600
										}}
									/>
								);
							}

							const days = row?.daysOverdue ?? 0;

							let color = '#2e7d32';
							let label = days;

							if (days > 0) {
								color = '#d32f2f';
							} else if (days === 0) {
								color = '#f59e0b';
								label = 'Hoy';
							}

							return (
								<Tag
									value={label}
									style={{
										background: 'transparent',
										border: 'none',
										color: color,
										fontWeight: 600
									}}
								/>
							);
						}}
					/>

					<Column
						header="Estado"
						headerStyle={headerStyle}
						style={centerStyle}
						body={(row) => {

							if ((row?.statusInvoice ?? "").toLowerCase() === "cancelada") {
								return (
									<Tag
										value="Cancelada"
										style={{
											background: "#991b1b",
											color: "#fff",
											border: "none"
										}}
									/>
								);
							}

							const status = getStatus(row);

							const severityMap = {
								Pagado: null,
								Vencida: 'danger',
								"Vence hoy": 'warning',
								Vigente: 'success'
							};

							return (
								<Tag
									value={status}
									severity={severityMap[status]}
									style={
										status === "Pagado"
											? {
												background: "#17c314",
												color: "#fff",
												border: "none"
											}
											: status === "Vence hoy"
												? {
													background: "#f59e0b",
													color: "#fff",
													border: "none"
												}
												: {}
									}
								/>
							);
						}}
					/>
					<Column
						field="isPaid"
						header="Pagada"
						headerStyle={headerStyle}
						style={centerStyle}
						body={(row) => {
							const isPaid = row?.isPaid === 1;

							return (
								<Tag
									value={isPaid ? "Sí" : "No"}
									severity={isPaid ? null : null}
									style={
										!isPaid
											? {
												background: "#dc2626",
												color: "#fff",
												border: "none"
											}
											: {
												background: "#17c314",
												color: "#fff",
												border: "none"
											}
									}
								/>
							);
						}}
					/>

					<Column
						field="paymentDate"
						header="Fecha de pago"
						headerStyle={headerStyle}
						style={centerStyle}
						body={(row) => {
							const hasDate = row?.paymentDate;

							return (
								<span
									style={{
										background: hasDate ? "#17c314" : "#dc2626",
										color: "#ffffff",
										padding: "4px 8px",
										borderRadius: "6px",
										display: "inline-block",
										width: "100%",
										fontWeight: 600,
										textAlign: "center"
									}}
								>
									{hasDate
										? new Date(row?.paymentDate).toLocaleDateString("es-MX")
										: "Sin pago"}
								</span>
							);
						}}
					/>

					<Column
						field="paymentAmount"
						header="Monto Pagado"
						headerStyle={headerStyle}
						style={centerStyle}
						body={(row) => `$${number_format(row?.paymentAmount, 2)}`}
						footer={`$${number_format(totalPagado, 2)}`}
						footerStyle={footerStyle}
					/>
				</DataTable>
			</div>
		);
	};




	// * CALCULATE SUMMARY (cards)
	const dashboardData = useMemo(() => {
		const today = new Date();

		let totalDeuda = 0;
		let totalVencido = 0;
		let promesasHoy = 0;

		let clientesMorososSet = new Set();

		reportBalance.forEach(client => {
			client.reportExpirationDateList.forEach(inv => {

				const isPaid = inv?.isPaid === 1;
				const amount = inv?.amount ?? 0;
				const expiration = inv?.expirationDate ? new Date(inv?.expirationDate) : null;

				// 🔹 TOTAL PAID
				if (!isPaid) {
					totalDeuda += amount;
				}

				// 🔹 VENCIDA
				const isOverdue = !isPaid && expiration && expiration < today;

				if (isOverdue) {
					totalVencido += amount;
					clientesMorososSet.add(client.clientId);
				}

				// 🔹 HOY (promesa de pago)
				const isToday =
					!isPaid &&
					expiration &&
					expiration.toDateString() === today.toDateString();

				if (isToday) {
					promesasHoy += amount;
				}

			});
		});

		return {
			totalDeuda,
			totalVencido,
			clientesMorosos: clientesMorososSet.size,
			promesasHoy
		};

	}, [reportBalance]);




	// * CONFIGURATION CHART
	const agingData = useMemo(() => {
		let corriente = 0;
		let d7 = 0;
		let d15 = 0;
		let d30 = 0;
		let d60 = 0;
		let d90 = 0;
		let d90plus = 0;

		reportBalance.forEach(client => {
			client.reportExpirationDateList.forEach(inv => {

				if (inv?.isPaid === 1) return;

				const amount = inv?.amount ?? 0;
				const days = inv?.daysOverdue ?? 0;

				if (days <= 0) corriente += amount;
				else if (days <= 7) d7 += amount;
				else if (days <= 15) d15 += amount;
				else if (days <= 30) d30 += amount;
				else if (days <= 60) d60 += amount;
				else if (days <= 90) d90 += amount;
				else d90plus += amount;
			});
		});

		return [corriente, d7, d15, d30, d60, d90, d90plus];

	}, [reportBalance]);

	const agingDetail = useMemo(() => {

		const result = {
			corriente: [],
			d7: [],
			d15: [],
			d30: [],
			d60: [],
			d90: [],
			d90plus: []
		};

		reportBalance.forEach(client => {

			const id_company = client.clientId;

			client.reportExpirationDateList.forEach(inv => {
				const idInvoice = inv.idInvoice;

				if (inv?.isPaid === 1) return;

				const item = {
					id: inv.id,
					id_company: id_company,
					cliente: client.clientName,
					folio: inv.folio,
					monto: inv.amount,
					days: inv.daysOverdue,
					idInvoice: idInvoice
				};

				const days = inv?.daysOverdue ?? 0;

				if (days <= 0) result.corriente.push(item);
				else if (days <= 7) result.d7.push(item);
				else if (days <= 15) result.d15.push(item);
				else if (days <= 30) result.d30.push(item);
				else if (days <= 60) result.d60.push(item);
				else if (days <= 90) result.d90.push(item);
				else result.d90plus.push(item);
			});
		});

		return result;

	}, [reportBalance]);




	// * CONFIGURATION CHART DETAIL
	const dataBar = {
		labels: ["Total"],
		datasets: [
			{
				label: "Corriente",
				data: [agingData[0]],
				backgroundColor: "#16a34a"
			},
			{
				label: "0-7 días",
				data: [agingData[1]],
				backgroundColor: "#a3e635"
			},
			{
				label: "8-15 días",
				data: [agingData[2]],
				backgroundColor: "#f8e805"
			},
			{
				label: "16-30 días",
				data: [agingData[3]],
				backgroundColor: "#fb923c"
			},
			{
				label: "31-60 días",
				data: [agingData[4]],
				backgroundColor: "#f87171"
			},
			{
				label: "61-90 días",
				data: [agingData[5]],
				backgroundColor: "#ef4444"
			},
			{
				label: "+90 días",
				data: [agingData[6]],
				backgroundColor: "#dc2626"
			}
		]
	};


	let pinnedTooltip = null;
	let isTooltipPinned = false;

	// * CONFIGURATION BAR
	const optionsBar = {
		indexAxis: "y",
		responsive: true,
		maintainAspectRatio: false,

		layout: {
			padding: 0
		},
		plugins: {
			tooltip: {
				enabled: false,


				external: function (context) {
					let tooltipEl = document.getElementById('chart-tooltip');

					if (!tooltipEl) {
						tooltipEl = document.createElement('div');
						tooltipEl.id = 'chart-tooltip';

						tooltipEl.style.position = 'absolute';
						tooltipEl.style.background = 'rgba(255,255,255,0.92)';
						tooltipEl.style.backdropFilter = 'blur(10px)';
						tooltipEl.style.webkitBackdropFilter = 'blur(10px)';
						tooltipEl.style.color = '#1f2937';
						tooltipEl.style.padding = '12px 14px';
						tooltipEl.style.borderRadius = '14px';
						tooltipEl.style.fontSize = '12px';
						tooltipEl.style.boxShadow = '0 12px 35px rgba(0,0,0,0.12)';
						tooltipEl.style.border = '1px solid rgba(229,231,235,0.8)';

						tooltipEl.style.pointerEvents = 'auto';
						tooltipEl.style.userSelect = 'text';

						tooltipEl.style.zIndex = 9999;
						tooltipEl.style.minWidth = '400px';
						tooltipEl.style.fontFamily = 'Inter, system-ui, sans-serif';
						tooltipEl.style.transition = 'all 0.12s ease';

						tooltipEl.addEventListener('mouseenter', () => {
							tooltipEl.setAttribute('data-hover', 'true');
						});

						tooltipEl.addEventListener('mouseleave', () => {
							tooltipEl.removeAttribute('data-hover');
							tooltipEl.style.opacity = 0;
						});

						document.body.appendChild(tooltipEl);
					}

					const tooltipModel = context.tooltip;
					// if (!isTooltipPinned && tooltipModel.opacity !== 0) {
					// 	pinnedTooltip = context;
					// }

					if (tooltipModel.opacity === 0) {
						if (!tooltipEl.hasAttribute('data-hover')) {
							tooltipEl.style.opacity = 0;
						}
						return;
					}

					// if (tooltipModel.opacity === 0 && !isTooltipPinned) {
					// 	if (!tooltipEl.hasAttribute('data-hover')) {
					// 		tooltipEl.style.opacity = 0;
					// 	}
					// 	return;
					// }

					// 👇 si está fijado usamos el último contexto
					if (isTooltipPinned && pinnedTooltip) {
						context = pinnedTooltip;
					}
					const datasetLabel = tooltipModel.dataPoints[0].dataset.label;
					const dataset = tooltipModel.dataPoints[0].dataset;
					const datasetColor = dataset.backgroundColor;

					const map = {
						"Corriente": agingDetail.corriente,
						"0-7 días": agingDetail.d7,
						"8-15 días": agingDetail.d15,
						"16-30 días": agingDetail.d30,
						"31-60 días": agingDetail.d60,
						"61-90 días": agingDetail.d90,
						"+90 días": agingDetail.d90plus
					};

					const items = map[datasetLabel] || [];

					let html = `
					<div style="
						display:flex;
						align-items:center;
						justify-content:space-between;
						margin-bottom:10px;
						padding-bottom:8px;
						border-bottom:1px solid #eef2f7;
					">
						<div style="display:flex; align-items:center; gap:8px;">
							<span style="
								width:10px;
								height:10px;
								border-radius:50%;
								background:${datasetColor};
							"></span>

							<span style="font-weight:600; font-size:13px;">
								${datasetLabel}
							</span>
						</div>

						<span style="font-size:11px; color:#9ca3af;">
					${items.length} ${items.length === 1 ? 'factura' : 'facturas'}
				</span>
					</div>
					`;

					html += `
					<div style="
						max-height:180px;
						overflow-y:auto;
						padding-right:4px;
					">
					`;

					items.forEach(i => {
						html += `
						<div style="
							display:flex;
							justify-content:space-between;
							align-items:center;
							padding:6px 0;
							border-bottom:1px solid #f9fafb;
						">
							<div style="display:flex; flex-direction:column;">
								<span style="font-size:12px; font-weight:500;">
									${i.cliente}
								</span>
								<span style="font-size:11px; color:#9ca3af;">
									${i.folio}
								</span>
							</div>

							<span style="font-weight:600; font-size:12px;">
								$${number_format(i.monto, 2)}
							</span>

							<button 
								class="go-factura"
								data-id="${i.id}" 
								data-company="${i.id_company}"
								data-invoice="${i.idInvoice}"
								style="
									background:#6366f1;
									color:white;
									border:none;
									border-radius:6px;
									padding:4px 8px;
									font-size:11px;
									cursor:pointer;
								"
							>
								Pagar
							</button>
						</div>
						`;
					});

					html += `</div>`;

					tooltipEl.innerHTML = html;

					tooltipEl.querySelectorAll('.go-factura').forEach(btn => {
						btn.onclick = (e) => {
							e.stopPropagation();
							const idCompany = btn.getAttribute('data-company');
							const idInvoice = btn.getAttribute('data-invoice');
							history.push(`../facturacion/complemento-pago/${idCompany}/${idInvoice}`);
						};
					});

					const canvasPosition = context.chart.canvas.getBoundingClientRect();
					const chart = context.chart;

					tooltipEl.style.opacity = 1;

					const tooltipWidth = tooltipEl.offsetWidth;
					const tooltipHeight = tooltipEl.offsetHeight;

					const dataPoint = tooltipModel.dataPoints[0];
					const element = dataPoint.element;

					const chartArea = chart.chartArea;
					const centerX = (chartArea.left + chartArea.right) / 2;

					let left = canvasPosition.left + centerX + window.scrollX;
					let top = canvasPosition.top + element.y + window.scrollY;

					left = left - (tooltipWidth / 2);
					top = top + 22;

					left = Math.min(
						window.scrollX + window.innerWidth - tooltipWidth - 12,
						Math.max(window.scrollX + 12, left)
					);

					top = Math.min(
						window.scrollY + window.innerHeight - tooltipHeight - 12,
						Math.max(window.scrollY + 12, top)
					);

					tooltipEl.style.left = `${left}px`;
					tooltipEl.style.top = `${top}px`;
				}
			},
			datalabels: {
				color: () => '#ffffff',

				font: {
					weight: 'bold',
					size: 16
				},

				textStrokeColor: 'rgba(0,0,0,0.4)',
				textStrokeWidth: 2,

				anchor: 'center',
				align: 'center',

				formatter: function (value) {
					if (!value || value === 0) return '';

					return new Intl.NumberFormat('es-MX', {
						style: 'currency',
						currency: 'MXN',
						minimumFractionDigits: 0
					}).format(value);
				}
			}
		},


		interaction: {
			mode: 'nearest',
			intersect: false,
			axis: 'x'
		},

		scales: {
			x: {
				stacked: true,
				grid: { display: false }
			},
			y: {
				stacked: true,
				display: false
			}
		},

		datasets: {
			bar: {
				barThickness: 45
			}
		},

	};



	// * CONFIGURATION COMPANY
	const topMorosos = useMemo(() => {

		const map = {};

		reportBalance.forEach(client => {
			let total = 0;

			client.reportExpirationDateList.forEach(inv => {
				if (inv.isPaid === 0 && inv.daysOverdue > 0) {
					total += inv.amount ?? 0;
				}
			});

			if (total > 0) {
				map[client.clientId] = {
					name: client.clientName,
					total
				};
			}
		});

		return Object.values(map)
			.sort((a, b) => b.total - a.total)
			.slice(0, 5);

	}, [reportBalance]);


	const getInvoiceStatusCount = (row) => {
		let overdue = 0;
		let todayDue = 0;

		const today = new Date();
		today.setHours(0, 0, 0, 0);

		row.reportExpirationDateList.forEach(inv => {

			if (inv.isPaid === 1) return;

			const exp = new Date(inv.expirationDate);
			exp.setHours(0, 0, 0, 0);

			if (exp < today) overdue++;
			else if (exp.getTime() === today.getTime()) todayDue++;
		});

		return { overdue, todayDue };
	};


	// *  CONFIGURATION HEIGHT BY ITEMS
	const getHeightByItems = (count) => {
		if (count >= 5) return 420;
		if (count === 4) return 380;
		if (count === 3) return 290;
		if (count === 2) return 200;
		return 200;
	};



	// * INDICATORS RESUMEN
	const indicators = reportBalance.reduce(
		(acc, client) => {
			acc.totalClients += 1;

			client.reportExpirationDateList.forEach(inv => {
				const today = new Date();
				today.setHours(0, 0, 0, 0);

				const exp = new Date(inv.expirationDate);
				exp.setHours(0, 0, 0, 0);

				if (inv.isPaid !== 1) {
					if (exp < today) acc.overdue += 1;
					if (exp.getTime() === today.getTime()) acc.todayDue += 1;
				}
			});

			return acc;
		},
		{
			totalClients: 0,
			overdue: 0,
			todayDue: 0
		}
	);

	const isClientCurrent = (() => {
		if (!filtersBalance.clientId) return false;

		const client = reportBalance?.find(
			c => c.clientId === filtersBalance.clientId
		);

		const invoices = client?.reportExpirationDateList || [];

		if (invoices.length === 0) return false;

		return invoices.every(inv => Number(inv.isPaid) === 1);
	})();





	return (
		<div className='container-global-zoom-Overdue' >
			<div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
				<Card style={{
					marginBottom: '15px',
					background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
					border: 'none',
					boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
				}}>
					<CardBody style={{ padding: '18px 25px' }}>
						<div className="d-flex align-items-center justify-content-between">
							<div className="d-flex align-items-center">
								<div style={{
									width: '50px',
									height: '50px',
									borderRadius: '12px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginRight: '15px'
								}}>
									<img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/overdueA.svg")} style={{ width: "80px", height: "80px" }} />
								</div>
								<div>
									<div style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										flexWrap: 'wrap',
										marginBottom: '10px'
									}}>

										{/* TÍTULO */}
										<h4
											className="mb-1"
											style={{
												color: '#fff',
												fontWeight: 700,
												fontSize: '20px',
												margin: 0
											}}
										>
											Resumen de Cobranza
										</h4>
									</div>
									<small>
										<div style={{
											display: 'flex',
											alignItems: 'center',
											gap: '10px',
											background: 'rgba(255,255,255,0.08)',
											padding: '6px 12px',
											borderRadius: '12px',
											color: '#fff',
											fontSize: '12px',
											fontWeight: 600,
											flexWrap: 'wrap'
										}}>

											<i className="fa fa-calendar" />

											Periodo:

											<span style={{ fontWeight: 700 }}>
												{filtersBalance.dateStart || '---'}
											</span>

											<span>-</span>

											<span style={{ fontWeight: 700 }}>
												{filtersBalance.dateEnd || '---'}
											</span>

											{filtersBalance.clientId && (
												<>
													<span style={{ opacity: 0.6 }}>|</span>

													<i className="fa fa-building" />

													<span style={{ fontWeight: 600 }}>
														{
															listOfClients?.find(
																c => c.id === filtersBalance.clientId
															)?.name
														}
													</span>
												</>
											)}


											{isClientCurrent && (
												<>
													<span style={{ opacity: 0.6 }}>|</span>

													<div style={{
														display: 'flex',
														alignItems: 'center',
														gap: '6px',
														background: 'rgba(23, 195, 20, 0.15)',
														border: '1px solid rgba(23, 195, 20, 0.4)',
														padding: '4px 10px',
														borderRadius: '10px',
														color: '#17c314',
														fontWeight: 700,
														fontSize: '12px'
													}}>
														<i className="fa fa-check-circle" />
														Cliente al corriente
													</div>
												</>
											)}

										</div>
									</small>
								</div>
							</div>

						</div>
					</CardBody>
				</Card>

				<Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
					<Col sm="12" className='pt-3'>
						<Row>
							<Col sm="12">
								<div style={{
									marginTop: '1px',
								}}>
									<Col sm="12" className='p-l-0 p-r-0' >

										{
											// * DASHBOARD CONFIGURATION INDICADORES
										}
										<div className="row mb-3">

											<div className="col-md-3">
												<div className="card dashboard-card-overduel">
													<div className="d-flex justify-content-between">
														<span className="card-title-overduel">Clientes morosos</span>

														<span className="trend-overduel down-overduel">
															<i className="icon-alert f-30 txt-warning  f-30"></i>
														</span>
													</div>
													<h2 className="card-value-overduel">
														{dashboardData.clientesMorosos}
													</h2>

													<div className="card-sub-overduel">Clientes</div>
													<div className="sparkline-overduel orange-overduel"></div>

												</div>
											</div>

											<div className="col-md-3">
												<div className="card dashboard-card-overduel">

													<div className="d-flex justify-content-between align-items-start">
														<span className="card-title-overduel ">Total deuda</span>

														<span className="trend-overduel up-overduel">
															<i className="icon-bar-chart-alt f-30"></i>
														</span>
													</div>

													<h2 className="card-value-overduel text-primary">
														${number_format(dashboardData.totalDeuda, 2)}
													</h2>

													<div className="card-sub-overduel">MXN</div>

													<div className="sparkline-overduel"></div>

												</div>
											</div>

											<div className="col-md-3">
												<div className={`card dashboard-card-overduel ${dashboardData.totalVencido > 0 ? 'card-danger-overduel' : ''}`}>

													<div className="d-flex justify-content-between">
														<span className="card-title-overduel">Total vencido</span>

														<span className="trend-overduel down-overduel">
															<i className="pi pi-arrow-down f-30"></i>
														</span>
													</div>

													<h2 className="card-value-overduel text-danger">
														${number_format(dashboardData.totalVencido, 2)}
													</h2>

													<div className="card-sub-overduel">MXN</div>
													<div className="sparkline-overduel red-overduel"></div>

												</div>
											</div>

											<div className="col-md-3">
												<div className={`card dashboard-card-overduel ${dashboardData.promesasHoy > 0 ? 'card-success-overduel' : ''
													}`}>

													<div className="d-flex justify-content-between">
														<span className="card-title-overduel">Promesas de pago hoy</span>

														<span className="trend-overduel">
															<i className="pi pi-exclamation-circle f-30"></i>
														</span>
													</div>

													<h2 className="card-value-overduel text-success">
														${number_format(dashboardData.promesasHoy, 2)}
													</h2>

													<div className="card-sub-overduel">MXN</div>
													<div className="sparkline-overduel green-overduel"></div>

												</div>
											</div>

										</div>
										{
											// * DASHBOARD CONFIGURATION AGING
										}
										<Col sm="12" className='pl-0 pr-0' >
											<Row>
												<Col sm="8">
													<div className="card p-3">
														<h6 className="mb-3">ANTIGÜEDAD DE SALDOS</h6>
														<div
															style={{
																height: `${getHeightByItems(topMorosos.length)}px`,
																overflow: "hidden"
															}}
														>
															<Bar data={dataBar} options={optionsBar} plugins={[ChartDataLabels]} // 👈 ESTE ES CLAVE
															/>
														</div>
													</div>
												</Col>

												<Col sm="4">
													<div className="card p-3" style={{
														borderRadius: "14px",
														border: "1px solid #eef2f7",
														boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
														background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)"
													}}>

														{/* HEADER */}
														<div style={{
															display: "flex",
															justifyContent: "space-between",
															alignItems: "center",
															marginBottom: "14px"
														}}>
															<h6 className="mb-3">TOP CLIENTES VENCIDOS</h6>


															<span style={{
																fontSize: "16px",
																background: "#fee2e2",
																color: "#b91c1c",
																padding: "3px 8px",
																borderRadius: "999px",
																fontWeight: 600
															}}>
																{topMorosos.length}
															</span>
														</div>

														{topMorosos.length === 0 && (
															<div style={{
																display: "flex",
																flexDirection: "column",
																alignItems: "center",
																justifyContent: "center",
																padding: "0px 10px",
																textAlign: "center"
															}}>

																{/* ICONO */}
																<div style={{
																	width: "70px",
																	height: "70px",
																	borderRadius: "16px",
																	background: "linear-gradient(135deg, #f1f5f9, #e2e8f0)",
																	display: "flex",
																	alignItems: "center",
																	justifyContent: "center",
																	marginBottom: "12px",
																	boxShadow: "inset 0 2px 6px rgba(0,0,0,0.05)"
																}}>
																	<img
																		src={require("../../../assets/images/laboratory-External/overdueNA.svg")}
																		style={{ width: "50px", height: "50px", opacity: 0.8 }}
																	/>
																</div>

																{/* TEXTO PRINCIPAL */}
																<div style={{
																	fontSize: "18px",
																	fontWeight: 600,
																	color: "#374151",
																	marginBottom: "4px"
																}}>
																	Sin clientes morosos
																</div>

																<div style={{
																	fontSize: "45px",
																	color: "#9ca3af",
																	maxWidth: "200px"
																}}>
																	🎉
																</div>

															</div>
														)}

														{topMorosos.map((c, index) => {

															const medal =
																index === 0 ? "🥇" :
																	index === 1 ? "🥈" :
																		index === 2 ? "🥉" : `#${index + 1}`;

															return (
																<div
																	key={index}
																	style={{
																		display: "flex",
																		alignItems: "center",
																		justifyContent: "space-between",
																		padding: "10px",
																		borderRadius: "12px",
																		marginBottom: "10px",
																		transition: "all 0.2s ease",
																		cursor: "pointer"
																	}}
																	onMouseEnter={(e) => {
																		e.currentTarget.style.background = "#f8fafc";
																		e.currentTarget.style.transform = "translateY(-2px)";
																	}}
																	onMouseLeave={(e) => {
																		e.currentTarget.style.background = "transparent";
																		e.currentTarget.style.transform = "translateY(0px)";
																	}}
																>

																	<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

																		<div style={{
																			width: "40px",
																			height: "40px",
																			borderRadius: "10px",
																			background: "#eff6ff",
																			display: "flex",
																			alignItems: "center",
																			justifyContent: "center"
																		}}>
																			<img
																				src={require("../../../assets/images/laboratory-External/buildingOverdue.svg")}
																				style={{ width: "40px", height: "40px" }}
																			/>
																		</div>

																		<div style={{ display: "flex", flexDirection: "column" }}>
																			<span
																				title={c.name}
																				style={{
																					fontSize: "13px",
																					fontWeight: 600,
																					maxWidth: "180px",
																					overflow: "hidden",
																					textOverflow: "ellipsis",
																					whiteSpace: "nowrap",
																				}}
																			>
																				{c.name}
																			</span>


																		</div>
																	</div>

																	{/* RIGHT */}
																	<div style={{ textAlign: "right" }}>
																		<div style={{
																			fontSize: "15px",
																			fontWeight: 700,
																			color: "#111827"
																		}}>
																			${number_format(c.total, 0)}
																		</div>

																		<div style={{
																			fontSize: "25px",
																			color: "#9ca3af"
																		}}>
																			{medal}
																		</div>
																	</div>

																</div>
															);
														})}

													</div>
												</Col>
											</Row>
										</Col>



										<Col sm="12" className='pl-0 pr-0 mt-5' >
											<h6 className="mb-3">FACTURAS VENCIDAS Y GESTION</h6>

											{
												// * FILTERS CONFIGURATION
											}
											<CardBody className='pb-5 pl-0 pr-0' style={{ padding: '16px' }}>

												<div style={{
													display: 'flex',
													alignItems: 'end',
													gap: '12px',
													flexWrap: 'wrap'
												}}>

													<div style={{ minWidth: '190px', flex: '0 0 170px' }}>
														<Label className='f-w-600 mb-1' style={{ fontSize: '12px', color: '#495057' }}>
															Fecha inicio
														</Label>

														<div style={{ position: 'relative' }}>
															<Input
																type='date'
																value={filtersBalance.dateStart}
																onChange={(e) =>
																	setFiltersBalance({ ...filtersBalance, dateStart: e.target.value })
																}
																disabled={loadingBalance}
																style={{
																	borderRadius: "12px",
																	height: "40px",
																	fontSize: "13px",
																	paddingLeft: '38px',
																	border: filtersBalance.dateStart ? '2px solid #1d5b83' : '1px solid #e0e0e0',
																	backgroundColor: filtersBalance.dateStart ? '#f8f9fa' : 'white'
																}}
															/>

															<div style={{
																position: 'absolute',
																left: '10px',
																top: '50%',
																transform: 'translateY(-50%)',
																color: filtersBalance.dateStart ? '#1d5b83' : '#adb5bd'
															}}>
																<i className="fa fa-calendar"></i>
															</div>
														</div>
													</div>

													<div style={{ minWidth: '190px', flex: '0 0 170px' }}>
														<Label className='f-w-600 mb-1' style={{ fontSize: '12px', color: '#495057' }}>
															Fecha fin
														</Label>

														<div style={{ position: 'relative' }}>
															<Input
																type='date'
																value={filtersBalance.dateEnd}
																onChange={(e) =>
																	setFiltersBalance({ ...filtersBalance, dateEnd: e.target.value })
																}
																disabled={loadingBalance}
																style={{
																	borderRadius: "12px",
																	height: "40px",
																	fontSize: "13px",
																	paddingLeft: '38px',
																	border: filtersBalance.dateEnd ? '2px solid #28a745' : '1px solid #e0e0e0',
																	backgroundColor: filtersBalance.dateEnd ? '#f8f9fa' : 'white'
																}}
															/>

															<div style={{
																position: 'absolute',
																left: '10px',
																top: '50%',
																transform: 'translateY(-50%)',
																color: filtersBalance.dateEnd ? '#28a745' : '#adb5bd'
															}}>
																<i className="fa fa-calendar"></i>
															</div>
														</div>
													</div>

													<div style={{ minWidth: '220px', flex: '0 0 220px' }}>
														<Label className='f-w-600 mb-1' style={{ fontSize: '12px', color: '#495057' }}>
															Cliente
														</Label>

														<Select
															options={listOfClients?.map((client) => ({
																value: client?.id,
																label: client?.name
															}))}

															value={
																filtersBalance.clientId
																	? {
																		value: filtersBalance.clientId,
																		label: listOfClients.find(c => c.id === filtersBalance.clientId)?.name
																	}
																	: null
															}

															onChange={(selected) => {
																setFiltersBalance({
																	...filtersBalance,
																	clientId: selected ? selected.value : null
																});
															}}

															placeholder="Selecciona"
															isClearable
															menuPortalTarget={document.body}

															styles={{
																control: (provided, state) => ({
																	...provided,
																	fontSize: '13px',
																	minHeight: '40px',
																	borderRadius: '12px',
																	border: state.isFocused || filtersBalance.clientId
																		? '2px solid #1d5b83'
																		: '1px solid #e0e0e0',
																	boxShadow: state.isFocused
																		? '0 0 0 2px rgba(29, 91, 131, 0.1)'
																		: 'none',
																	backgroundColor: filtersBalance.clientId ? '#f8f9fa' : 'white'
																})
															}}
														/>
													</div>

													<div>
														<Button
															onClick={handleGetReportBalance}
															color="primary"
															disabled={loadingBalance}
															style={{
																borderRadius: '12px',
																height: '40px',
																padding: '0 18px',
																fontWeight: 600,
																background: (!filtersBalance.dateStart && !filtersBalance.dateEnd && !filtersBalance.clientId)
																	? '#e9ecef'
																	: 'linear-gradient(135deg, #1d5b83, #0d3b59)',
																border: 'none'
															}}
														>
															{loadingBalance ? 'Buscando...' : 'Buscar'}
														</Button>
													</div>

													<div>
														<Button
															color="success"
															disabled={reportBalance?.length === 0 || loadingBalance || downloading}
															style={{
																borderRadius: '12px',
																height: '40px',
																padding: '0 18px',
																fontWeight: 600
															}}
															onClick={() => exportToExcelBalance(reportBalance)}
														>
															{downloading ? 'Descargando...' : 'Descargar'}
														</Button>
													</div>


													<div style={{
														display: 'flex',
														alignItems: 'center',
														gap: '12px',
														marginLeft: 'auto',
														flexWrap: 'wrap'
													}}>

														<div
															className='kpi-card kpi-clients'
															style={{
																display: 'flex',
																alignItems: 'center',
																gap: '12px',
																padding: '10px 16px',
																borderRadius: '16px',
																background: 'rgba(29, 91, 131, 0.08)',
																border: '1px solid rgba(29, 91, 131, 0.25)',
																whiteSpace: 'nowrap',
																minWidth: '160px'
															}}>
															<img
																src={require("../../../assets/images/laboratory-External/overdue3.svg")}
																style={{ width: "44px", height: "44px" }}
															/>

															<div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
																<span style={{ fontSize: '14px', color: '#6c757d' }}>Clientes</span>
																<span style={{ fontSize: '18px', fontWeight: 700, color: '#1d5b83' }}>
																	{indicators.totalClients}
																</span>
															</div>
														</div>

														<div
															className='kpi-card overdue'
															style={{
																display: 'flex',
																alignItems: 'center',
																gap: '12px',
																padding: '10px 16px',
																borderRadius: '16px',
																background: 'rgba(220, 38, 38, 0.08)',
																border: '1px solid rgba(220, 38, 38, 0.25)',
																whiteSpace: 'nowrap',
																minWidth: '160px'
															}}>
															<img
																src={require("../../../assets/images/laboratory-External/overdue1.svg")}
																style={{ width: "44px", height: "44px" }}
															/>

															<div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
																<span style={{ fontSize: '14px', color: '#6c757d' }}>Vencidas</span>
																<span style={{ fontSize: '18px', fontWeight: 700, color: '#dc2626' }}>
																	{indicators.overdue}
																</span>
															</div>
														</div>

														<div
															className='kpi-card kpi-today'
															style={{
																display: 'flex',
																alignItems: 'center',
																gap: '12px',
																padding: '10px 16px',
																borderRadius: '16px',
																background: 'rgba(245, 158, 11, 0.10)',
																border: '1px solid rgba(245, 158, 11, 0.25)',
																whiteSpace: 'nowrap',
																minWidth: '160px'
															}}>
															<img
																src={require("../../../assets/images/laboratory-External/overdue2.svg")}
																style={{ width: "44px", height: "44px" }}
															/>

															<div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
																<span style={{ fontSize: '14px', color: '#6c757d' }}>Vence hoy</span>
																<span style={{ fontSize: '18px', fontWeight: 700, color: '#f59e0b' }}>
																	{indicators.todayDue}
																</span>
															</div>
														</div>
													</div>
												</div>
											</CardBody>
											{
												//* DATATABLE CONFIGURATION
											}
											<DataTable
												value={reportBalance}
												expandedRows={expandedRows}
												onRowToggle={(e) => setExpandedRows(e.data)}
												rowExpansionTemplate={rowExpansionTemplate}
												dataKey="clientId"
												paginator
												rows={10}
												loading={loadingBalance}
												emptyMessage={
													<div className="text-center py-5">
														<img
															src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
															style={{ width: "400px", maxWidth: "32%" }}
															alt="Sin resultados"
														/>
														<p className='mt-3 mb-0' style={{ fontSize: "15px", color: "#6c757d" }}>
															No se encontraron resultados en este periodo seleccionado.
														</p>
													</div>
												}
											>
												<Column
													expander
													headerStyle={headerStyle}
													style={centerStyle}
													footer=""
												/>

												<Column
													field="clientName"
													header="Cliente"
													sortable
													headerStyle={headerStyle}
													style={centerStyle}
													body={(row) => {

														const { overdue, todayDue } = getInvoiceStatusCount(row);

														return (

															<div style={{
																display: 'flex',
																alignItems: 'center',
																gap: '8px',
																justifyContent: 'center'
															}}>
																<span>{row.clientName}</span>

																{overdue > 0 && (
																	<span style={{
																		background: '#d32f2f',
																		color: 'white',
																		borderRadius: '50%',
																		minWidth: '22px',
																		height: '22px',
																		display: 'flex',
																		alignItems: 'center',
																		justifyContent: 'center',
																		fontSize: '12px',
																		fontWeight: 700
																	}}>
																		{overdue}
																	</span>
																)}

																{todayDue > 0 && (
																	<span style={{
																		background: '#f59e0b',
																		color: 'white',
																		borderRadius: '50%',
																		minWidth: '22px',
																		height: '22px',
																		display: 'flex',
																		alignItems: 'center',
																		justifyContent: 'center',
																		fontSize: '12px',
																		fontWeight: 700
																	}}>
																		{todayDue}
																	</span>
																)}
															</div>
														);
													}}
													footer=""
												/>

												<Column
													field="commercialLine"
													header="Razón social"
													sortable
													headerStyle={headerStyle}
													style={centerStyle}
													footer=""
												/>

												<Column
													field="rfc"
													header="RFC"
													sortable
													headerStyle={headerStyle}
													style={centerStyle}
													footer="Montos"
													footerStyle={footerStyle}
												/>

												<Column
													header="Monto facturadp"


													body={(row) => {
														const total = row.reportExpirationDateList.reduce(
															(acc, inv) => acc + inv.amount,
															0
														);
														return `$${number_format(total, 2)}`;
													}}
													headerStyle={headerStyle}
													style={centerStyle}
													footer={`$${number_format(totalGeneral, 2)}`}
													footerStyle={footerStyle}
												/>

												<Column
													header="Monto Pagado"
													headerStyle={headerStyle}
													style={centerStyle}
													body={(row) => {
														const totalPaid = row.reportExpirationDateList.reduce(
															(acc, inv) => acc + (inv.paymentAmount ?? 0),
															0
														);
														return `$${number_format(totalPaid, 2)}`;
													}}
													footer={`$${number_format(totalPaidGeneral, 2)}`}
													footerStyle={footerStyle}
												/>
											</DataTable>
										</Col>
									</Col>
								</div>
							</Col>
						</Row>
					</Col>
				</Card>
			</div >
		</div >
	)
}


